import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentListComponent } from './document-list.component';
import { TreeModule } from '@circlon/angular-tree-component';
import { DocumentsService } from '../../../../../services/communication/documents.service';


@NgModule({
    declarations: [
        DocumentListComponent,
    ],
    exports: [
        DocumentListComponent,
    ],
    imports: [
        CommonModule,
        TreeModule,
    ],
    providers: [
        DocumentsService,
    ],
})
export class DocumentListModule
{
}
